const OwnerIdsEnum = Object.assign({
  exporo: 'exporo',
});

Object.freeze(OwnerIdsEnum);

export default OwnerIdsEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/OwnerIds.js